import { fragmentOn } from 'basehub'

export const changelogEntryFragment = fragmentOn('ChangelogTemplateComponent', {
  _id: true,
  _title: true,
  _slug: true,
  subtitle: true,
  content: {
    json: {
      content: true,
      toc: true,
      blocks: {
        __typename: true,
        on_CalloutComponent: {
          _id: true,
          intent: true,
          content: { json: { content: true } },
          _slug: true,
        },
      },
    },
  },
  narration: { url: true },
  version: true,
  authorS: {
    _title: true,
    name: true,
    x: true,
    avatar: {
      url: true,
      alt: true,
    },
  },
  publishDate: true,
  analytics: {
    pageViews: { ingestKey: true },
  },
})

export type ChangelogEntry = fragmentOn.infer<typeof changelogEntryFragment>

export const changelogIndexFragment = fragmentOn('Changelog', {
  header: {
    title: true,
    subtitle: true,
  },
  entries: {
    __args: {
      orderBy: 'publishDate__DESC',
    },
    items: changelogEntryFragment,
  },
  analytics: {
    pageViews: { ingestKey: true },
  },
})

export type ChangelogIndex = fragmentOn.infer<typeof changelogIndexFragment>
